import { render } from "./projectsChart1.vue?vue&type=template&id=4a4fa065"
import script from "./projectsChart1.vue?vue&type=script&lang=js"
export * from "./projectsChart1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__